var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(!_vm.$route.meta.isStandalone)?_c('com-head'):_vm._e(),(!_vm.$route.meta.isStandalone)?_c('com-panel'):_vm._e(),_c('com-content',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }